import { HttpClient, HttpParams, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { NhaCungCapModelLite } from '../__model/common_config.model';

const API_ROOT_URL_DANHMUC = environment.ApiRoot + '/danhmuc';
const API_ROOT_URL_DUNGCHUNG = environment.ApiRoot + '/dungchung';
const API_ROOT_URL_NCC = environment.ApiRoot + '/nhacungcap';
const API_ROOT_URL = environment.ApiRoot + '/nhomhanghoa';
const API_ROOT_URL_HANGHOA = environment.ApiRoot + '/hanghoa';
const API_ROOT_URL_DANHMUC_IMPORT = environment.ApiRoot + '/importdanhmucfile';
const API_ROOT_URL_QR = environment.ApiRoot + '/kho';
const API_EXPORT_URL = environment.ApiExport;
const API_ROOT_USER = environment.ApiRoot + '/UserNFC';

@Injectable({
  providedIn: 'root'
})

export class DungChungService {
  lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
  lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
  lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
  data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
  listDemos$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  ReadOnlyControl: boolean;
  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService) { }

  listNCC(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_ROOT_URL_DANHMUC + '/DM_NCC_List', null, { headers: httpHeaders });
  }
  listNCC_CongNo(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_ROOT_URL_DANHMUC + '/DM_NCC_List_CongNo', null, { headers: httpHeaders });
  }

  getNCCById(IdNcc: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/NCC_Info_ByID?IdNcc=${IdNcc}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listStatus(category_path: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DANHMUC + `/Get_DS_TrangThai?Category_path=${category_path}`, { headers: httpHeaders });
  }

  listNV(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_NhanVien_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listKH(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_KhachHangCha_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  getCustomersWithoutBranch(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_KhachHangCha_List';
    const body = { isGetBranch: false };
    return this.http.post<any>(url, body, { headers: httpHeaders });
  }

  listDoiTuong(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_DoiTuong_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listLoaiTien(IdTT: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = environment.ApiRoot + `/tiente/LayDanhSachTienTe?IdTT=${IdTT}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listLoaiKH(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_LoaiKhachHang_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  listPB(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_PhongBan_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }
  listFileData(id: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/DM_File_List?id=${id}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  /*downloadFile(id: number): Observable<Blob>{
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/DownLoadFile?IdCt=${id}` ;
    return this.http.get<Blob>(url, {
      headers: httpHeaders,
      responseType: 'blob' as 'json'
    });
  }*/
  downloadFile(id: number): string {
    return API_ROOT_URL_DANHMUC + `/DownLoadFile?IdCt=${id}`;
  }
  getFile(id: number): Observable<Blob> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/DownLoadFile?IdCt=${id}`;
    return this.http.get<Blob>(url, { headers: httpHeaders, responseType: 'blob' as 'json' });
  }
  getHHById(id: number) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/GetHHById?id=${id}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listHangHoa(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/Hang_Hoa_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listHangHoaOnly(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/Hang_Hoa_Only_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listHangHoaTheoNhieuLoai(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/Get_HH_Theo_Multiple_LoaiHH`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getProductByMultiType(productTypes: number[]): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/get-product-by-multi-type';
    let params = new HttpParams();
    productTypes.forEach(type => {
      params = params.append('productTypes', type.toString());
    });
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }

  listHangHoaThanhPhamBTP(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/Get_HH_ThanhPham_BTP`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listKho(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/Kho_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listKhoTheoQuyen(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/Kho_List?filterQuyen=true';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listState(category_path: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/TrangThaiPhieu_List?category=${category_path}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listNVTheoPB(IdPB: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/NhanVienPB_List?id=${IdPB}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getDSVTK(IdKho: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/ViTriKho_List?IdKho=${IdKho}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  getDSVTKEmpty(IdKho: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/ViTriKhoEmpty_List?IdKho=${IdKho}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listNVPB(id: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/NhanVienPB_List?id=${id}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listNVPBs(ids: number[]): Observable<any> {
    let params = new HttpParams();
    ids.forEach(x => params = params.append('id', x.toString()));

    return this.http.get<any>(`${API_ROOT_URL_DUNGCHUNG}/NhanVienPBs_List`, {
      headers: this.httpUtils.getHTTPHeaders(),
      params
    });
  }
  listLot(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/LotHH_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listTonKho(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/TonKhoHienTai_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listDVT(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_DVT_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  listLoaiHH(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/GetAllLoaiHH';
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listNhomHH(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/GetAllNhomHH';
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listNhomHHTheoLoai(IdLoai: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/ListNhomHH_TheoLoai?Id=${IdLoai}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  sendNotificationsToSetting(IdNof: number, message: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = environment.ApiRoot + '/nof' + `/pushNof?IdNof=${IdNof}&message=${message}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listLoaiNCC(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_LoaiNCC_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  listTinh(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_Tinh_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  setNCC(data: NhaCungCapModelLite): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_NCC + '/DM_NhaCungCap_Insert';
    return this.http.post<any>(url, data, { headers: httpHeaders });
  }

  getHinhThucThanhToan(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/HinhThucThanhToan';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  getHopDongTheoNCC(id: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/HopDongTheoNCC`;
    let params = new HttpParams().set('IdNCC', id.toString())
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }

  getDSTienTe(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DanhSachTienTe';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  getDSDonViTinh(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DM_DVT_List';
    return this.http.post<any>(url, null, { headers: httpHeaders });
  }

  // Import nhom hh
  downloadTemplate(tenNHH: string): Observable<Blob> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const params = new HttpParams().set('tenNHH', tenNHH);
    return this.http.get<Blob>(API_ROOT_URL_DANHMUC + '/DownLoadFileImportMau', {
      headers: httpHeaders,
      params: params,
      responseType: 'blob' as 'json'
    });
  }

  uploadFileImport(data): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + '/ImportFile';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(url, data, { headers: httpHeaders });
  }

  createMultipleLoai(item): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_ROOT_URL_DANHMUC + '/DM_NhomHangHoa_Mutiple_Insert', item, { headers: httpHeaders });
  }

  getDanhSachMaNhomHH(idLoaiHH: number): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = new HttpParams().set("IdLoai", idLoaiHH.toString())
    return this.http.get<any>(API_ROOT_URL_DANHMUC + '/DM_NhomHangHoa_MaNhomHHLite', {
      headers: httpHeaders,
      params: httpParams
    });
  }

  exportFileExcel(queryParams: QueryParamsModel): Observable<Blob> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    return this.http.get<Blob>(API_ROOT_URL_DANHMUC + '/ExportFile', {
      headers: httpHeaders,
      params: httpParams,
      responseType: 'blob' as 'json'
    });
  }

  // Import hh
  downloadTemplateHH(idLoaiHH: number, tenHH: string): Observable<Blob> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const params = new HttpParams().set('idLoaiHH', idLoaiHH.toString()).set('tenHH', tenHH);
    return this.http.get<Blob>(API_ROOT_URL_HANGHOA + '/DownLoadFileImportMau', {
      headers: httpHeaders,
      params: params,
      responseType: 'blob' as 'json'
    });
  }

  uploadFileImportHH(data): Observable<any> {
    const url = API_ROOT_URL_HANGHOA + '/ImportFile';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(url, data, { headers: httpHeaders });
  }

  createMultipleHH(item): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_ROOT_URL_HANGHOA + '/DM_Mutiple_Insert', item, { headers: httpHeaders });
  }

  getDanhSachMaHH(idLoaiHH: number): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = new HttpParams().set("IdLoai", idLoaiHH.toString())
    return this.http.get<any>(API_ROOT_URL_HANGHOA + '/DM_MaHHLite', {
      headers: httpHeaders,
      params: httpParams
    });
  }

  getDanhSachMaHHLite(): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = new HttpParams()
    return this.http.get<any>(API_ROOT_URL_HANGHOA + '/DM_MaHH_Lite', {
      headers: httpHeaders,
      params: httpParams
    });
  }
  getDanhSachNhomHH(idLoaiHH: number): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = new HttpParams().set("IdLoai", idLoaiHH.toString())
    return this.http.get<any>(API_ROOT_URL_HANGHOA + '/DM_MaNhomHHLite', {
      headers: httpHeaders,
      params: httpParams
    });
  }

  exportFileExcelHH(queryParams: QueryParamsModel): Observable<Blob> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    return this.http.get<Blob>(API_ROOT_URL_HANGHOA + '/ExportFile', {
      headers: httpHeaders,
      params: httpParams,
      responseType: 'blob' as 'json'
    });
  }

  getHanMucPhongBan(idPb: any) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/HanMucPhongBan?idPB=${idPb}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getHanMucPhongBanTheoDK(idPb: any, isKeHoach: boolean) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/HanMucPhongBan?idPB=${idPb}&isKeHoach=${isKeHoach}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getHanMucDuyetPhongBan(idPb: any, idLoaiHH: any) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/HanMucDuyetPhongBan?idPB=${idPb}&idLoaiHH=${idLoaiHH}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listChiNhanhAll(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CCTC_CN_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listCongDoanSanXuat(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CDSX_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listPhongBanAll(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CCTC_PB_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listBoPhanAll(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CCTC_BP_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listBoPhanLv3All(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CCTC_BP_List_Lv3';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listHDDangSuDung(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/HD_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  listPhongBanTheoChiNhanh(IdChiNhanh: number): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CCTC_CN_List';
    const parms = new HttpParams().set('IdChiNhanh', IdChiNhanh.toString());
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders, params: parms });
  }

  listBoPhanTheoCNvaPB(IdChiNhanh: number, IdPhongBan: number): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CCTC_CN_List';
    const parms = new HttpParams().set('IdChiNhanh', IdChiNhanh.toString()).set('IdPhongBan', IdPhongBan.toString());
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders, params: parms });
  }

  getBillNumber(category_path: string): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/CreateBillNumber';
    const parms = new HttpParams().set('category_path', category_path.toString());
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders, params: parms });
  }

  layDanhSachHangHoaTonKhoHienTai(): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + '/LayDanhSachHangHoaTheoKhoSoLo';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachHangHoaTonKhoHienTaiTheoRoles(IdPhieu: number = 0, RunXuatKho: number = 0, lID: number[] = []): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + '/LayDanhSachHangHoaTheoKhoSoLoRoles';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const params = new HttpParams().set("IdPhieu", IdPhieu.toString()).set("RunXuatKho", RunXuatKho.toString()).set("lID", lID.toString());
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }

  layDanhSachHangHoaConSoLuongTon(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/LayDanhSachHangHoaConSoLuongTon';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachHangHoaTheoLoai(idLoai: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/Get_HH_Theo_LoaiHH?id=${idLoai}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  layDanhSachHangHoaTheoLoaiAll(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/Get_HH_Theo_LoaiHHAll`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listGiaNhaCungConHanSD(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/GiaMuaNCC_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listGiaNhaCungConHanSDTheoHH(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/GiaMuaNCCByHH_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachDMChiPhiTinhGia(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DanhSachDMChiPhiTinhGia';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachSanPhamYeuCauBaoGia(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/SanPhamBaoGia_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachYCBG(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/DanhSachDMChiPhiTinhGia';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachYeuCauBaoGia(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/YeuCauBaoGia_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachSanPhamTheoPhieuBaoGia(IdBaoGia: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/SanPhamByPhieuBG_List?IdBaoGia=${IdBaoGia}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachHHTheoLoai(idHH: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/HHTheoLoai_List?idHH=${idHH}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  layDanhSachHHTheoNhieuLoai(queryParams: QueryParamsModel): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    const url = API_ROOT_URL_DANHMUC + `/HHChung_List`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,
        params: httpParams
      });
  }

  layDanhSachKhachHang(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/KhachHangList`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      });
  }
  
  getBranchListByCustomerId(customerIds: number[]): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(false);
    const url = API_ROOT_URL_DANHMUC + '/branchbycustomer';
    return this.http.post<any>(url, { customerIds: customerIds }, { 
      headers: httpHeaders
    });
  }

  layDanhSachMauPhieuKhaoSat(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + '/TemplateKhaoSat_List';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachHHDaNhapKho(queryParams: QueryParamsModel): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    const url = API_ROOT_URL_DANHMUC + `/GetAllHHDaNhapKho`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,
        params: httpParams
      });
  }

  layDanhSachLoaiPhieu(LoaiNhapXuat: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = new HttpParams().set("LoaiNhapXuat", LoaiNhapXuat.toString());
    const url = API_ROOT_URL_DANHMUC + `/DanhSach_LoaiPhieu`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,
        params: httpParams
      });
  }
  layChiTietHangTonKho_List(idHH, idKho): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/ChiTietHangTonKho_List?idHH=${idHH}&idKho=${idKho}`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      });
  }
  listKhuVucSanXuatTheoBoPhan(IdBP: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/KVSX_List?id=${IdBP}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listGiaiDoanHangHoa(): Observable<any> {
    const url = API_ROOT_URL_DUNGCHUNG + '/GDHH_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listDMKhoAuthorized(): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + '/DMKhoAuthorizedByUser_List';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listHistoryHHXuatKho(dnck_ct): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + `/HistoryHHXuatKho_List?dnck_ct=${dnck_ct}`;
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listHistoryHHNhapKho(dnck_ct): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + `/HistoryHHNhapKho_List?dnck_ct=${dnck_ct}`;
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  layDanhMucCanImport(): Observable<any> {
    const url = API_ROOT_URL_DANHMUC + `/LayDanhSachChucNangCanImport`;
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  layDanhSachNCCTheoNhom_TKMuaHang(queryParams: QueryParamsModel): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    const url = API_ROOT_URL_DANHMUC + `/NCC_List_MuaHang`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,
        params: httpParams
      });
  }
  layDanhSachHHTheoLoaiHH_TKMuaHang(queryParams: QueryParamsModel): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    const url = API_ROOT_URL_DANHMUC + `/HH_List_MuaHang`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,
        params: httpParams
      });
  }
  layGiaMuaTheoKHvsHH(idKH: number, idHH): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/GiaMuaHanNhat?idKH=${idKH}&idHH=${idHH}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  layDanhSachNoiDungDGNCC(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/NoiDungDGNCC_List`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      });
  }

  layDanhSachYeuCauDGNCC_ForVisit(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/YeuCauDGNCCForVisit_List`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      })
  }
  layDanhSachYeuCauDGNCC_ForChecklist(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/YeuCauDGNCCForChecklist_List`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      })
  }

  layDanhSachLoaiLoiKN(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/LoaiLoiKhieuNai_List`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      })
  }


  layKhachHangBaseHH(idHH: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/KhachHangBaseHH_List?id=${idHH}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDSYeuCauNghienCuu(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/YCNC_List`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDSPhieuThuNghiemTheoYCNC(Id: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/PTN_BaseYCNC_List?id=${Id}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDSGiaiDoanSanXuat(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/GDSX_List`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layGDTP(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/GDSX_List_TP`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDSThietBiFromKV(listKv: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/getListThietBiFromKV?request=${listKv}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachHHByKH(Id): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_DANHMUC + `/DSHHByKH_List?IDKH=${Id}`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders,

      });
  }

  layDanhSachHangHoaInit(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/DanhSachHangHoaInit`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachLotKhongXuatKhoInit(IdHH: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/DanhSachLotHH_KhongDuocXuatInit?IdHH=${IdHH}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachKVSXFromQTSX(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/KVSX_List_ByQTSX`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  layDanhSachBOM(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/BOM_List`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getPhieuChiById(itemId: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/PhieuChi_Detail?Id=${itemId}`, { headers: httpHeaders });
  }
  getPhieuThuById(itemId: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/PhieuThu_Detail?Id=${itemId}`, { headers: httpHeaders });
  }
  isCTBH(itemId: any, paymentMethod: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/isCTBH?Id=${itemId}&paymentMethods=${paymentMethod}`, { headers: httpHeaders });
  }
  isCTBHTL(itemId: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/isCTBHTL?Id=${itemId}`, { headers: httpHeaders });
  }
  ChungTuMuaHangTrongNuoc(itemId: any, paymentMethod: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/ChungTuMuaHangTrongNuoc?Id=${itemId}&paymentMethods=${paymentMethod}`, { headers: httpHeaders });
  }

  getDSModule(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/List_Module`, { headers: httpHeaders });
  }
  getDSMenu(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/List_Menu`, { headers: httpHeaders });
  }
  getDSAllMenu(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/List_All_Menu`, { headers: httpHeaders });
  }
  getHHCTList(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DUNGCHUNG + `/HHBomCT_List`, { headers: httpHeaders });
  }

  getListWarehouseWithIdHH(id_hh: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DANHMUC + `/KhoTonKho_List?idhh=${id_hh}`, { headers: httpHeaders });
  }

  getListInventoryWithIdHHIdKho(id_hh: number, id_kho: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DANHMUC + `/DanhSachThongTinTonKho?IdHH=${id_hh}&IdKho=${id_kho}`, { headers: httpHeaders });
  }

  getListMerchandises(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/ListMerchandises`;
    return this.http.get<any>(url,
      {
        headers: httpHeaders
      });
  }

  listLOTWithIdHH(idhh: number): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_DANHMUC + `/ListLOTWithParamsIdHH?idhh=${idhh}`, { headers: httpHeaders });
  }
  layDSNhomCTKiemTra(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/NhomCTKiemTra_List`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  layDSCTKiemTraBaseOnGroup(idNhom: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/CTKiemTra_BaseOnGroup?idNhom=${idNhom}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  downloadFileQuyCachDatMa(): string {
    return API_ROOT_URL_HANGHOA + `/DownloadFileQuyCachDatMa`;
  }

  layThongTinNganHang(id: number, type : number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + `/LayThongTinNganHang?id=${id}&type=${type}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  getValueConfigBaseOnConfigCode(configCode: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/GetValueConfigBaseOnConfigCode?configCode=${configCode}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  listId_MaThongKe(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot+`/ketoan` + `/MaThongKe_GetList`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getNgamDinhHangHoaById(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot+`/ketoan/NgamDinhHangHoaById?InventoryItemId=${item}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	getMersInventoryBaseOnRoles(bodyParams: any): Observable<any> {
		const url = API_ROOT_URL_DANHMUC + '/LayDanhSachHangHoaTheoKhoSoLoRoles';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, bodyParams, { headers: httpHeaders });
	}

	getDefaultUnit1(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL_DUNGCHUNG + '/Unit_Info';
		return this.http.get<any>(url, { headers: httpHeaders });
	}

  listDVT1() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_DVT_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}

	getListDevice() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/list_device' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}

  // ------ Lấy danh sách hàng hóa danh mục
  top_list_of_merchandise(keyword: string = "", top: number = 0, idLoai: number = 0): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/top_list_of_merchandise';
    var params = new HttpParams().set("keyword", keyword).set("top", top.toString()).set("idLoai", idLoai.toString());
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }
  top_list_of_merchandise_lite(keyword: string = "", top: number = 0, idLoai: number = 0): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DANHMUC + '/top_list_of_merchandise_lite';
    var params = new HttpParams().set("keyword", keyword).set("top", top.toString()).set("idLoai", idLoai.toString());
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }
  getHHListDM(keyword, loaiHHId): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + '/List_DM_HangHoa';
    var params = new HttpParams()
                .set("keyword", keyword)
                .set("loaiHHId", loaiHHId);
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }
  listTagKho(): Observable<QueryResultsModel>{
    const queryParams = new QueryParamsModel(
      {},
			"NgayTao",
			"desc",
			0,
			10,
			[],
			true
		);
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    return this.http.get<any>(environment.ApiRoot + '/tagkho' + '/dm_tagkho_list', { 
      headers: httpHeaders,
      params: httpParams
    });
	}
  getlistTagKhoForFilter(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/tagkho' + '/dm_tagkho_listFilter';
		return this.http.get<any>(url, { headers: httpHeaders });
	}

  ListVTKConfigDM(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + '/dm_vtk_config_list';
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  // .. API download template
	downloadTemplateImport(idLoai): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set('idLoai', idLoai);
		return this.http.get<Blob>(API_ROOT_URL_DANHMUC_IMPORT + '/DownloadFileTemplate', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	}
  
	// .. API import file
	startImportFile(data): Observable<any> {
		const url = API_ROOT_URL_DANHMUC_IMPORT + '/handle_file_import';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders});
	}

  // .. API save data import
  saveChangeDataImport(data): Observable<any> {
		const url = API_ROOT_URL_DANHMUC_IMPORT + '/save_import_data';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders});
	}

  getInfoConfigDateNXK(type: any) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/kho_config_date_nx?configType=${type}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  saveConfigDateNXK(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL_DUNGCHUNG + '/kho_config_date_nx_save', item, { headers: httpHeaders });
	}

  // .. API list reasons warehouse
  listReasonsWarehouse(paramsCode: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const params = new HttpParams().set("code", paramsCode);
    const url = API_ROOT_URL_DANHMUC + '/list-reasons-warehouse';
    return this.http.get<any>(url, { headers: httpHeaders, params: params });
  }

  // .. LẤY THÔNG TIN CẤU HÌNH THỜI GIAN ĐƯỢC PHÉP HỦY XUẤT/NHẬP
  getWarehouseCancellationTimeConfig(type: any) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + `/warehouse-cancellation-time-config?configType=${type}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  // .. LƯU THÔNG TIN CẤU HÌNH THỜI GIAN ĐƯỢC PHÉP HỦY XUẤT/NHẬP
  saveWarehouseCancellationTimeConfig(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL_DUNGCHUNG + '/save-warehouse-cancellation-time-config', item, { headers: httpHeaders });
	}
  mahoaQR(data: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_ROOT_URL_QR + '/ma_hoa_pallet';
    return this.http.post<any>(url, {data:data}, { headers: httpHeaders });
  }
  // .. LỊCH SỬ THAO TÁC KHO
  lichsuthaotackho(data: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = `${API_ROOT_URL_DUNGCHUNG}/kho_lsthaotac_get?Id=${data.Id}&menu=${data.menu}`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  // THÔNG TIN LOCK PHIẾU ĐỀ NGHỊ
  getInfoLockRequestForm(data: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + '/get_info_lock_request_form';
    return this.http.post<any>(url, data, { headers: httpHeaders });
  }
  unlockRequestForm(data: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_ROOT_URL_DUNGCHUNG + '/unlock_request_form';
    return this.http.post<any>(url, data, { headers: httpHeaders });
  }

  //Export dùng chung
  XuatExcelTonKho(queryParams: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_EXPORT_URL + '/export', queryParams, {
			headers: httpHeaders,
		});
	}
  XuatExcelTonKhoShortTime(queryParams: any): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post(API_EXPORT_URL + '/export-short', queryParams, { headers: httpHeaders, responseType: 'blob' });
	}
  XuatExcelMenu(queryParams: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_EXPORT_URL + '/export-menu-long', queryParams, {
			headers: httpHeaders,
		});
	}
  getSQLQueryForExport(queryParams: QueryParamsModel, type): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
    const urlMap = {
      DeNghiNhapKho: '/kho/NK_ExportExcel_Filter',
      DeNghiXuatKho: '/report/de-nghi-xuat-kho',
      NhapKho: '/kho/NK_ExportExcel_Filter',
      XuatKho: '/report/xuat-kho',
      DeNghiChuyenKho: '/report/de-nghi-chuyen-kho',
      ChuyenKho: 'pi/report/chuyen-kho',
      ChuyenKhoNoiNo: '/report/chuyen-kho-noi-no',
      default: '/report/default'
  };
  let a = environment.ApiRoot + `${urlMap[type]}`
		return this.http.get<any>( environment.ApiRoot + `${urlMap[type]}`, { 
			headers: httpHeaders,
			params: httpParams
		});
	}
  XuatExcelMenuShortTime(queryParams: any): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post(API_EXPORT_URL + '/export-menu-short', queryParams, { headers: httpHeaders, responseType: 'blob' });
	}
  checkPermissions(permissions: string[]): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_ROOT_USER + '/check-permissions', permissions, {	headers: httpHeaders});
  }

  getWarehouseByProducts(products: number[]): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_ROOT_URL_QR + '/get-warehouses-by-products', { ProductIds: products }, { headers: httpHeaders });
  }

  getExecutors(): Observable<any> { 
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(API_ROOT_URL_QR + '/get-executors', { headers: httpHeaders });
  }
}
